export default __webpack_public_path__ + "static/media/crossIcon.ca414224.svg";